/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type RectangularCoordinatesFragment = { xMin: number, yMax: number, xMax: number, yMin: number };

export type FloatRangeFragment = { max: number, min: number, step: number };

export type DeviceCoverageAudioCoverageAreaFragment = { id: string, isCoverageAreaNode: 'AudioCoverageArea', description: { index: number, constraints: { gain: { gain: { range: FloatRangeFragment } | null } | null, configuration: { type: { options: Array<{ type: { options: Types.AudioCoverageAreaType }, width: { range: FloatRangeFragment }, height: { range: FloatRangeFragment }, distance: { range: FloatRangeFragment } }> } } | null }, features: { gain: { supported: boolean }, mute: { supported: boolean }, configuration: { supported: boolean } } }, features: { configuration: { active: boolean, type: Types.AudioCoverageAreaType, coordinates: RectangularCoordinatesFragment } | null, gain: { gain: number } | null, mute: { muted: boolean } | null } };

export type DeviceCoverageAudioCoverageAreaUpdateFragment = { id: string, features:
    | { configuration: { active: boolean, type: Types.AudioCoverageAreaType, coordinates: RectangularCoordinatesFragment } | null }
    | { gain: { gain: number } | null }
    | { mute: { muted: boolean } | null }
   };

export type GetCoverageAudioCoverageAreaQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetCoverageAudioCoverageAreaQueryOpResult = { node:
    | DeviceCoverageAudioCoverageAreaFragment
    | Record<PropertyKey, never>
   };

export type CoverageAudioCoverageAreaSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type CoverageAudioCoverageAreaSubscriptionOpResult = { nodeChanges:
    | DeviceCoverageAudioCoverageAreaFragment
    | DeviceCoverageAudioCoverageAreaUpdateFragment
    | Record<PropertyKey, never>
   };

export type UpdateAudioCoverageAreaMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateAudioCoverageAreaMutationOpResult = { updateNodes: Array<
    | { error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
  > };

export type ActivateAudioCoverageAreaMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  type: Types.AudioCoverageAreaType;
  coordinates: Types.RectangularCoordinatesInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ActivateAudioCoverageAreaMutationOpResult = { activateAudioCoverageArea: { error: { code: Types.ErrorCode, message: string } | null } };

export type DeactivateAudioCoverageAreaMutationVariables = Types.Exact<{
  coverageAreaId: Types.Scalars['ID']['input'];
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DeactivateAudioCoverageAreaMutationOpResult = { deactivateAudioCoverageArea: { error: { code: Types.ErrorCode, message: string } | null } };

export type UpdateAudioCoverageAreaPositionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  coordinates: Types.RectangularCoordinatesInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateAudioCoverageAreaPositionMutationOpResult = { repositionAudioCoverageArea: { error: { code: Types.ErrorCode, message: string } | null } };

export const FloatRangeFragment = gql`
    fragment FloatRangeFragment on FloatRange {
  max
  min
  step
}
    `;
export const RectangularCoordinatesFragment = gql`
    fragment RectangularCoordinatesFragment on RectangularCoordinates {
  xMin
  yMax
  xMax
  yMin
}
    `;
export const DeviceCoverageAudioCoverageAreaFragment = gql`
    fragment DeviceCoverageAudioCoverageAreaFragment on AudioCoverageArea {
  isCoverageAreaNode: __typename
  id
  description {
    index
    constraints {
      gain {
        gain {
          range {
            ...FloatRangeFragment
          }
        }
      }
      configuration {
        type {
          options {
            type {
              options
            }
            width {
              range {
                ...FloatRangeFragment
              }
            }
            height {
              range {
                ...FloatRangeFragment
              }
            }
            distance {
              range {
                ...FloatRangeFragment
              }
            }
          }
        }
      }
    }
    features {
      gain {
        supported
      }
      mute {
        supported
      }
      configuration {
        supported
      }
    }
  }
  features {
    configuration {
      active
      coordinates {
        ...RectangularCoordinatesFragment
      }
      type
    }
    gain {
      gain
    }
    mute {
      muted
    }
  }
}
    ${FloatRangeFragment}
${RectangularCoordinatesFragment}`;
export const DeviceCoverageAudioCoverageAreaUpdateFragment = gql`
    fragment DeviceCoverageAudioCoverageAreaUpdateFragment on AudioCoverageAreaChange {
  id
  features {
    ... on AudioCoverageAreaGainChange {
      gain {
        gain
      }
    }
    ... on AudioCoverageAreaMuteChange {
      mute {
        muted
      }
    }
    ... on AudioCoverageAreaConfigurationChange {
      configuration {
        active
        coordinates {
          ...RectangularCoordinatesFragment
        }
        type
      }
    }
  }
}
    ${RectangularCoordinatesFragment}`;
export const GetCoverageAudioCoverageAreaQueryDocument = gql`
    query GetCoverageAudioCoverageAreaQuery($id: ID!) {
  node(id: $id) {
    ...DeviceCoverageAudioCoverageAreaFragment
  }
}
    ${DeviceCoverageAudioCoverageAreaFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCoverageAudioCoverageAreaQueryGQL extends Apollo.Query<GetCoverageAudioCoverageAreaQueryOpResult, GetCoverageAudioCoverageAreaQueryVariables> {
    override document = GetCoverageAudioCoverageAreaQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CoverageAudioCoverageAreaSubscriptionDocument = gql`
    subscription CoverageAudioCoverageAreaSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...DeviceCoverageAudioCoverageAreaFragment
    ...DeviceCoverageAudioCoverageAreaUpdateFragment
  }
}
    ${DeviceCoverageAudioCoverageAreaFragment}
${DeviceCoverageAudioCoverageAreaUpdateFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CoverageAudioCoverageAreaSubscriptionGQL extends Apollo.Subscription<CoverageAudioCoverageAreaSubscriptionOpResult, CoverageAudioCoverageAreaSubscriptionVariables> {
    override document = CoverageAudioCoverageAreaSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAudioCoverageAreaMutationDocument = gql`
    mutation UpdateAudioCoverageAreaMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    ... on AudioCoverageAreaOperationResult {
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAudioCoverageAreaMutationGQL extends Apollo.Mutation<UpdateAudioCoverageAreaMutationOpResult, UpdateAudioCoverageAreaMutationVariables> {
    override document = UpdateAudioCoverageAreaMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateAudioCoverageAreaMutationDocument = gql`
    mutation ActivateAudioCoverageAreaMutation($id: ID!, $type: AudioCoverageAreaType!, $coordinates: RectangularCoordinatesInput!, $injectKeyring: String) {
  activateAudioCoverageArea(
    id: $id
    type: $type
    coordinates: $coordinates
    keyring: $injectKeyring
  ) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateAudioCoverageAreaMutationGQL extends Apollo.Mutation<ActivateAudioCoverageAreaMutationOpResult, ActivateAudioCoverageAreaMutationVariables> {
    override document = ActivateAudioCoverageAreaMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateAudioCoverageAreaMutationDocument = gql`
    mutation DeactivateAudioCoverageAreaMutation($coverageAreaId: ID!, $injectKeyring: String) {
  deactivateAudioCoverageArea(id: $coverageAreaId, keyring: $injectKeyring) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateAudioCoverageAreaMutationGQL extends Apollo.Mutation<DeactivateAudioCoverageAreaMutationOpResult, DeactivateAudioCoverageAreaMutationVariables> {
    override document = DeactivateAudioCoverageAreaMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAudioCoverageAreaPositionMutationDocument = gql`
    mutation UpdateAudioCoverageAreaPositionMutation($id: ID!, $coordinates: RectangularCoordinatesInput!, $injectKeyring: String) {
  repositionAudioCoverageArea(
    id: $id
    coordinates: $coordinates
    keyring: $injectKeyring
  ) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAudioCoverageAreaPositionMutationGQL extends Apollo.Mutation<UpdateAudioCoverageAreaPositionMutationOpResult, UpdateAudioCoverageAreaPositionMutationVariables> {
    override document = UpdateAudioCoverageAreaPositionMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }